import { Target } from "lucide-react";

function formatTimestamp(epochSeconds) {
  if (!epochSeconds) return "—";
  const d = new Date(epochSeconds * 1000);
  if (isNaN(d.getTime())) return "—";
  const mm = String(d.getMonth() + 1).padStart(2, "0");
  const dd = String(d.getDate()).padStart(2, "0");
  const HH = String(d.getHours()).padStart(2, "0");
  const MM = String(d.getMinutes()).padStart(2, "0");
  return `${mm}/${dd} ${HH}:${MM}`;
}

function fmtBlind(v) {
  if (v == null || v === 0) return null;
  // Si es entero exacto → mostrar sin decimales (ej. 18, 36).
  // Si tiene fracción → 2 decimales como PPPoker (0.6 → "0.60", 1.2 → "1.20").
  const n = Number(v);
  if (!Number.isFinite(n)) return null;
  if (Number.isInteger(n)) return String(n);
  return n.toFixed(2);
}

/**
 * HeaderBar — réplica nativa del header del history detail PPPoker.
 *
 * Layout 1:1:
 *   [05/08 17:15]  [◎ 0.60/1.20]
 *   [hand_id]
 *
 * El icono ◎ (Target) emula el "chip" de poker que muestra PPPoker iOS al
 * lado de las stakes.
 */
export function HeaderBar({ summary, hand }) {
  if (!summary) return null;
  const date = formatTimestamp(summary.started_at_raw);
  const handId = summary.hand_id;

  // Stakes SB/BB (lo que muestra PPPoker en la cabecera, ej. "0.60/1.20")
  // Nota: usar small_blind_chips antes que sb_amount porque ese último a veces
  // contiene un valor pre-migración (iblind del protobuf) en lugar del SB real.
  const sb = fmtBlind(hand?.small_blind_chips ?? hand?.sb_amount);
  const bb = fmtBlind(hand?.bb_amount ?? hand?.big_blind_chips);
  const stakes = sb && bb ? `${sb}/${bb}` : null;

  return (
    <header
      className="flex flex-col gap-1 px-3 py-3 border-b border-white/10"
      data-testid="native-detail-header"
    >
      <div className="flex items-center gap-3 text-[13px] text-slate-200">
        <span className="tabular-nums" data-testid="hand-date">
          {date}
        </span>
        {stakes && (
          <span
            className="flex items-center gap-1.5 text-slate-200"
            data-testid="hand-stakes"
          >
            <Target className="h-3.5 w-3.5" />
            <span className="tabular-nums font-semibold">{stakes}</span>
          </span>
        )}
      </div>
      <div
        className="text-[13px] font-mono text-slate-300 break-all"
        data-testid="hand-id-text"
      >
        {handId}
      </div>
    </header>
  );
}
